module.exports = __webpack_public_path__ + "media/images/taxi-f2939d8f3efba5f969926d8bb5513c5c.svg";